import axios from 'axios';
import { REGISTER_SUCCESS,
    REGISTER_FAIL ,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CLEAR_PROFILE
} from './types';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken';
//load USer
export const loadUser = () => async dispatch => {
    if(localStorage.token) {
        setAuthToken(localStorage.token)
    }
    try {
        const res =await axios.get('https://devconnecter-backend.onrender.com/api/auth');
        dispatch({
            type:USER_LOADED,
            payload:res.data
        })
    } catch (err) {
       dispatch({
        type:AUTH_ERROR
       }) 
    }
}

//Register user
export const register = ({name,email,password})=>async dispatch => {
    const config = {
        headers: {
            'Content-Type':'application/json'
        }
    }

    const body = JSON.stringify({name,email,password});
 
    try {
        const res = await axios.post('https://devconnecter-backend.onrender.com/api/users',body,config);
       console.log(res.data.token)
       console.log("REGISTER_SUCCESS")
        dispatch({ 
            type: REGISTER_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());
    } catch (err) {
        //const errors = err.response.data.errors;
        const errors = err.response?.data?.errors;
        if(errors) {
            errors.forEach(error  => dispatch(setAlert(error.msg,'danger')))
                
            }else {
                dispatch(setAlert('Registration failed', 'danger')); // Handle generic error
              }
        
        dispatch({
            type: REGISTER_FAIL,
        });
    }   
    }


    //Login user
export const login = ({email,password})  =>  
async dispatch => {
    const config = {
        headers: {
            'Content-Type':'application/json'
        }
    }
 
    const body = JSON.stringify({email, password});
    console.log(body)
    try {
        const res = await axios.post('https://devconnecter-backend.onrender.com/api/auth',body,config);
    
       console.log(body)
       console.log("Login_SUCCESS")
        dispatch({ 
            type: LOGIN_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());
    } catch (err) {
      
        const errors = err.response?.data?.errors;
        if(errors) {
            errors.forEach(error  => dispatch(setAlert(error.msg,'danger')))
                
            }else {
                dispatch(setAlert('Registration failed', 'danger')); // Handle generic error
              }
        
        dispatch({
            type: LOGIN_FAIL,
        });
    }   
    }
//LOGOUT/clear profile
export const logout = () => dispatch => {
    dispatch({type:LOGOUT});
    dispatch({type:CLEAR_PROFILE})
}